<template>
    <v-dialog
            v-model="showOverlay"
            hide-overlay
            persistent
            width="300"
    >
        <v-card
                color="primary"
                dark
        >
            <v-card-text>
                <template v-if="status === 0">
                    a carregar ...
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </template>
                <template v-if="status === -1">
                    <v-btn @click="$emit('tryAgain')">tentar novamente</v-btn>
                    <v-btn class="ml-2" text @click="$emit('logout')">sair</v-btn>
                </template>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "CustomOverlay",

        props: {
            status: {
                default: 0,
                type: Number,
            }
        },

        computed: {
            showOverlay: {
                get(){
                    return this.$store.getters.getShowOverlay;
                },
                set(value){
                    this.$store.dispatch('setShowOverlay', value);
                }
            },
        },

    }
</script>

<style scoped>

</style>